<template>
  <div class="content">
    <div class="second" v-for="(item, index) in Technology" :key="index">
      <!-- <h2>{{ item.title }}</h2> -->
      <p v-html=item.content></p>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'Second',
        props: {
          Technology: {
            type: Array,
            default: () => ([])
          },
        },
        mounted() {
        },
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.second {
  padding: 0px 65px 0 28px;
}
.second h2 {
  font-size: 20px;
  color:#343434;
  margin-bottom: 50px;
  font-weight: bold;
}
.second p{
  color:#4a4a4a;
  font-size:16px;
  line-height:29px;
  margin-bottom: 30px;
}
::v-deep .second p span{
  font-size:20px !important;
  font-weight:bold;
  margin-bottom:25px;
  margin-top: 35px;
  display:block;
}
</style>